import { Suspense, useEffect, useState, lazy } from 'react'

const placeholder = <div className="w-full h-[500px] bg-zinc-100 rounded-lg animate-pulse" />

export function USMapView(props) {
  const [MapComponent, setMapComponent] = useState(null)

  useEffect(() => {
    // Dynamic import only runs on client — never during SSR
    import('@/components/LeafletMap').then((mod) => setMapComponent(() => mod.default))
  }, [])

  if (!MapComponent) return placeholder

  return (
    <Suspense fallback={placeholder}>
      <MapComponent {...props} />
    </Suspense>
  )
}
